export const translations = {
  en: {
    hero: {
      title: "Best place buy and sell crypto currency asset",
      subtitle: "Accelerate the world's transition",
      description: "We are at the forefront of the digital currency revolution. Founded by a team of passionate blockchain enthusiasts and financial experts, our mission is to empower individuals and businesses by providing innovative solutions in the cryptocurrency space.",
      exploreServices: "At SB Group, we offer a comprehensive suite of services designed to meet the diverse needs of cryptocurrency traders. Let's explore our key services below:",
      walletSolutions: "Wallet Solutions",
      walletDesc: "We offer both hot and cold wallets to ensure your cryptocurrencies are safe and accessible whenever you need them.",
      tradingPlatform: "Crypto Trading Platform",
      tradingDesc: "Buy, sell, and trade a wide range of cryptocurrencies with real-time market data and advanced charting tools to inform your decisions.",
      marketInsights: "Market Insights Analytics",
      marketDesc: "Our team of experts provides regular market reports, price alerts, and trend analysis to help you make informed trading decisions.",
      customerSupport: "Customer Support",
      supportDesc: "Whether you have questions about our services or need help with your account, we’re just a message away.",
      welcome: "Welcome to SB Group where cutting-edge technology meets user-friendly design to provide you with an unparalleled cryptocurrency trading experience.",
      ourFeatures: "Our Features",
      featuresSubtitle: "All you need is here",
      featuresWelcome: "Welcome to SB Group where cutting-edge technology meets user-friendly design to provide you with an unparalleled cryptocurrency trading experience. Let’s Explore our standout features",
      tradingTools: "Advanced Trading Tools",
      toolsDesc: "Utilize cutting-edge trading tools including real-time charts, .. etc to enhance your trading strategy",
      highLiquidity: "High Liquidity",
      liquidityDesc: "Experience seamless trading with high liquidity across a wide range of cryptocurrencies.",
      educationalResources: "Educational Resources",
      educationDesc: "Access a wealth of educational content, including to enhance your trading knowledge and skills.",
      liveSupport: "24/7 Live Support",
      supportTeam: "Our dedicated support team is available around the clock to assist you with any issues you may encounter."
    },
    navbar: {
      home: "Home",
      whyUs: "Why Us",
      about: "About US",
      services: "Services",
      features: "Features",
      contact: "Contact Us"
    },
    whyUsPage: {
      title: "Why SB Group?",
      feature1: "Advanced Security Technologies",
      feature2: "Global Standards Compliant Solutions",
      feature3: "Professional Support",
      feature4: "Digital Assets Expertise"
    },
    buttons: {
      getStarted: "Get Started",
      watchTutorials: "Watch Tutorials",
      exploreServices: "Explore Services",
      learnMore: "Learn More",
      contactUs: "Contact Us"
    },
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Operation successful",
      selectLanguage: "Select Language",
      clients: "Happy Clients",
      projects: "Projects Completed",
      support: "Support Available",
      years: "Years Experience"
    },
    servicesPage: {
      services: "Our Services",
      subtitle: "Provide The Best Services",
      description: "At SB Group, we offer a comprehensive suite of services designed to meet the diverse needs of cryptocurrency traders, Let's Explore our key services below:"
    },
    contactPage: {
      title: "Contact With Us",
      subtitle: "We are always with you",
      description: "If you have any problem at any time, please contact us. Regards, SB Group",
      email: "Email",
      phone: "Phone Number",
      message: "Message",
      send: "Send"
    },
    footer: {
      description: "Our platform is designed to cater to both beginners and experienced traders, offering a seamless experience that empowers you to navigate the exciting world of digital assets with confidence",
      exploreTitle: "Explore",
      contactTitle: "Contact",
      addressDamascus: "Damascus, Salhiya - Opposite Parliament",
      addressAleppo: "Aleppo, Al-Furqan - Behind Al Baraka Bank",
      damascus: "Damascus",
      aleppo: "Aleppo",
      rights: "Designed and Developed by"
    }
  },
  ar: {
    hero: {
      title: "أفضل مكان لشراء وبيع أصول العملات المشفرة",
      subtitle: "تسريع عملية التحول في العالم",
      description: "نحن في طليعة ثورة العملات الرقمية. أسسنا فريق من المتحمسين لتقنية البلوك تشين والخبراء الماليين.",
      exploreServices: "في SB Group نوفر منظومة متكاملة من الحلول المالية المبتكرة بخبرة اكثر من 25 عاماً صُممت خصيصاً لتسهيل إدارة أصولك الرقمية وتعزيز الأمان وضمان وصولك إلى أموالك في أي وقت وبأعلى درجات الثقة..",
      walletSolutions: "حلول المحفظة",
      walletDesc: "نحن نقدم محافظ ساخنة وباردة لضمان أمان عملاتك المشفرة وإمكانية الوصول إليها وقتما تحتاج إليها.",
      tradingPlatform: "منصة تداول العملات المشفرة",
      tradingDesc: "قم بشراء وبيع وتداول مجموعة واسعة من العملات المشفرة باستخدام بيانات السوق في الوقت الفعلي.",
      marketInsights: "تحليلات رؤى السوق",
      marketDesc: "يوفر فريق الخبراء لدينا تقارير السوق لمساعدتك على اتخاذ قرارات تداول مستنيرة.",
      customerSupport: "دعم العملاء",
      supportDesc: "سواء كان لديك أسئلة حول خدماتنا أو تحتاج إلى مساعدة، فنحن على بعد رسالة واحدة فقط.",
      welcome: "مرحباً بكم في مجموعة SB، حيث تلتقي التكنولوجيا المتطورة مع التصميم سهل الاستخدام.",
      ourFeatures: "مميزاتنا",
      featuresSubtitle: "كل ما تحتاجه هنا",
      featuresWelcome: "مرحباً بكم في مجموعة SB حيث تلتقي التكنولوجيا المتطورة مع التصميم سهل الاستخدم لتزويدك بتجربة تداول عملات مشفرة لا مثيل لها. دعنا نستكشف ميزاتنا البارزة",
      tradingTools: "أدوات تداول متقدمة",
      toolsDesc: "استخدم أدوات التداول المتطورة بما في ذلك الرسوم البيانية في الوقت الفعلي لتعزيز استراتيجية التداول الخاصة بك",
      highLiquidity: "سيولة عالية",
      liquidityDesc: "اختبر تداولاً سلسًا مع سيولة عالية عبر مجموعة واسعة من العملات المشفرة.",
      educationalResources: "الموارد التعليمية",
      educationDesc: "احصل على ثروة من المحتوى التعليمي، بما في ذلك ما يعزز معرفتك ومهاراتك في التداول.",
      liveSupport: "دعم مباشر 24/7",
      supportTeam: "فريق الدعم المخصص لدينا متاح على مدار الساعة لمساعدتك في أي مشكلات قد تواجهها."
    },
    navbar: {
      home: "الرئيسية",
      whyUs: "لماذا نحن",
      about: "من نحن",
      services: "خدماتنا",
      features: "المميزات",
      contact: " تواصل معنا"
    },
    whyUsPage: {
      title: "لماذا SB Group؟",
      feature1: "تقنيات أمان متقدمة",
      feature2: "حلول متوافقة مع المعايير العالمية",
      feature3: "دعم احترافي",
      feature4: "خبرة في مجال الأصول الرقمية"
    },
    buttons: {
      getStarted: "ابدأ الآن",
      watchTutorials: "شاهد الدروس",
      exploreServices: "استكشف الخدمات",
      learnMore: "المزيد",
      contactUs: " تواصل معنا"
    },
    common: {
      loading: "جاري التحميل...",
      error: "حدث خطأ",
      success: "تمت العملية بنجاح",
      selectLanguage: "اختر اللغة",
      clients: "عملاء سعداء",
      projects: "مشروع مكتمل",
      support: "دعم متاح",
      years: "سنوات خبرة"
    },
    servicesPage: {
      services: "خدماتنا",
      subtitle: "تقديم أفضل الخدمات",
      description: " في SB Group نوفر منظومة متكاملة من الحلول المالية المبتكرة بخبرة اكثر من 25 عاماً صُممت خصيصاً لتسهيل إدارة أصولك الرقمية وتعزيز الأمان وضمان وصولك إلى أموالك في أي وقت وبأعلى درجات الثقة.."
    },
    contactPage: {
      title: "تواصل معنا",
      subtitle: "نحن دائماً معك",
      description: "إذا واجهت أي مشكلة في أي وقت، يرجى الاتصال بنا. مع تحيات، مجموعة SB",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      message: "الرسالة",
      send: "إرسال"
    }, 
    footer: {
      description: "تم تصميم منصتنا لتلبي احتياجات المبتدئين والمتداولين ذوي الخبرة على حد سواء، مما يوفر تجربة سلسة تمكنك من التنقل في عالم الأصول الرقمية المثير بثقة.",
      exploreTitle: "اكتشف",
      contactTitle: "تواصل معنا",
      addressDamascus: "دمشق، الصالحية، مقابل البرلمان",
      addressAleppo: "حلب، الفرقان، خلف بنك البركة",
      damascus: "دمشق",
      aleppo: "حلب",
      rights: "تم التصميم والتطوير بواسطة"
    }
  }
};
